import React from "react";
import styles from "./password-rules.module.css";

const PasswordRules = ({ password = "" }) => {
  const isTouched = password?.length > 0;

  const passwordChecks = {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[@$!%*?&]/.test(password),
  };

  const getStatusClass = (condition) => {
    if (!isTouched) return styles.neutral;
    return condition ? styles.valid : styles.invalid;
  };

  return (
    <div className={styles.passwordRules}>
      <p className={styles.ruleTitle}>Password must contain:</p>
      <ul>
        <li className={getStatusClass(passwordChecks.length)}>
          At least 8 characters
        </li>

        <li className={getStatusClass(passwordChecks.upper)}>
          One uppercase letter
        </li>

        <li className={getStatusClass(passwordChecks.lower)}>
          One lowercase letter
        </li>

        <li className={getStatusClass(passwordChecks.number)}>
          One number
        </li>

        <li className={getStatusClass(passwordChecks.special)}>
          One special character (@$!%*?&)
        </li>
      </ul>
    </div>
  );
};

export default PasswordRules;